import { toPlacingJSON } from './Placing';

export class Wall {
  constructor(wallData) {
    this.id = wallData ? wallData.id : null;
    this.width = wallData ? wallData.width : null;
    this.height = wallData ? wallData.height : null;
    this.color = '2800F0';
    this.placings = [];
    this.index = wallData && wallData.index ? wallData.index : 0;

    this.removedPlacings = [];
  }
}

export const copyWall = (wall, anotherWall) => {
  wall.id = anotherWall.id;
  wall.width = anotherWall.width;
  wall.height = anotherWall.height;
  wall.color = '2800F0';
  wall.index = anotherWall.index;
  wall.placings = anotherWall.placings;
};

export const toWallJSON = wall => {
  const wallJSON = {
    id: wall.id,
    width: wall.width,
    height: wall.height,
    color: wall.color,
    placings_attributes: prepareWallPlacings(wall)
  };
  return wallJSON;
};

export const prepareWallPlacings = wall => {
  const wallPlacingsJSON = {};
  let continueIndex = 0;

  wall.placings.forEach(placing => {
    wallPlacingsJSON[continueIndex++] = toPlacingJSON(placing);
  });
  wall.removedPlacings.forEach(placing => {
    placing.destroy = true;
    wallPlacingsJSON[continueIndex++] = toPlacingJSON(placing);
  });
  return wallPlacingsJSON;
};
